/*
 *  Project: dux - multi select
 *  Description: Toggle multi select on item list
 *  Author: bwin
 */

;(function ( $, window, document, undefined ){

    'use strict';

    var pluginName = 'dv_itemlist',
        _self,
        defaults = {};

    function Plugin( element, options ){

        _self = this;
        this.element = element;
        this.$element = $( element );

        this.options = $.extend( {}, defaults, options );

        this._defaults = defaults;
        this._name = pluginName;
    }

    $.extend( Plugin.prototype, {
        init: function (){
            // useless
        },
        multiselect: function ( type ){

            if ( typeof type === 'string' && type === 'show' ) {
                this._showMultiSelect();
            } else if ( typeof type === 'string' && type === 'hide' ) {
                this._hideMultiSelect()
            } else {
                console.info( 'Supported arguments are "show" and "hide".' );
            }

        },
        _showMultiSelect: function (){
            this.$element
                .toggleClass( 'multiselect' )
                .toggleClass( 'in' );
        },
        _hideMultiSelect: function (){
            this.$element
                .toggleClass( 'in out' );

            setTimeout( function (){
                _self.$element.removeClass( 'out multiselect' );
            }, 300 )
        }
    } );

    $.fn[ pluginName ] = function ( options ){
        var args = arguments;

        if ( options === undefined || typeof options === 'object' ) {

            return this.each( function (){

                if ( !$.data( this, 'plugin_' + pluginName ) ) {
                    $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
                }

            } );

        } else if ( typeof options === 'string' && options[ 0 ] !== '_' && options !== 'init' ) {

            var returns;

            this.each( function (){

                var instance = $.data( this, 'plugin_' + pluginName );

                if ( instance instanceof Plugin && typeof instance[ options ] === 'function' ) {
                    returns = instance[ options ].apply( instance, Array.prototype.slice.call( args, 1 ) );
                }

                if ( options === 'destroy' ) {
                    $.data( this, 'plugin_' + pluginName, null );
                }

            } );

            return returns !== undefined ? returns : this;
        }
    };

})( jQuery, window, document );


;(function ( $, window, document, undefined ){
    $( function (){

        $( '.item-list' ).each( function (){

            var $this = $( this );
            $this.dv_itemlist();

        } );
    } );
})( jQuery, window, document );